module.exports = __webpack_public_path__ + "media/Video 11.70a228ce.mp4";